import { createBrowserRouter, createHashRouter, Navigate, RouterProvider } from "react-router-dom";

import Home from "../home";
import Landing from "./Landing";
//Report
import Report from "../report/report"
import Activity from "../report/activity"
import Dashboard from "../report/dashboard";
//fiscal
import Fiscal from "../report/fiscal/fiscal"
import FiscalExpenditure from "../report/fiscal/fiscalExpenditure";
import FiscalMuseum from "../report/fiscal/fiscalMuseum";
import FiscalBreadcrump from "../report/fiscal/fiscalBreadcrump";
import FiscalView from "../report/fiscal/fiscalView";
//operational
import Operational from "../report/operational/operational"
import OperationalView from "../report/operational/operationalView";
import OperationalResponse from "../report/operational/operationalResponse";
//performance
import Performance from "../report/performance/performance"
import PerformanceView from "../report/performance/performanceView";
import PerformanceResponse from "../report/performance/performanceResponse";


//visitation
import Visitation from "../report/visitation/visitation";
import VisitationResponse from "../report/visitation/visitationResponse";
import VisitationView from "../report/visitation/visitationView";
import AdminAdd from "../report/admin/adminAdd";

// Reports
import VisitationMonthReport from "../report/reports/visitationMonthReport";
import VisitationMonthAdRentReport from "../report/reports/visitationMonthAdRentReport";
import VisitationMonthDetailedReport from "../report/reports/visitationMonthDetailedReport";
import VisitationAnnualReport from "../report/reports/visitationAnnualReport";
import VisitationAnnualAdRentReport from "../report/reports/visitationAnnualAdRentReport";

import SiteAnnualReport from "../report/reports/siteAnnualReport"
import SiteAssociateAnnualReport from "../report/reports/siteAssociateAnnualReport";
import SiteAnnualProgrammingReport from "../report/reports/siteAnnualProgrammingReport";

import OperationalReport from "../report/operational/operationalReport";
import SignIn from "../../signIn";
import Login from "../../login";
import FiscalResponse from "../report/fiscal/fiscalResponse";
import FiscalExpenditureResponse from "../report/fiscal/fiscalExpenditureResponse";
import FiscalMuseumResponse from "../report/fiscal/fiscalMuseumResponse";



function Navigation() {

    const router = createBrowserRouter([
        {
            path: "/",
            element: <Landing />,
            children: [
                {
                    index: true,
                    element: <Navigate to="/dashboard" replace />,
                    // when user navigate to / it automaticly navigate to /home
                },
                {
                    path: "home",
                    element: <Home />
                },
                {
                    path: "dashboard",
                    element: <Dashboard />
                },

                {
                    path: "fiscal",
                    element: <Fiscal />,
                },
                {
                    path: "fiscal/:id",
                    element: <Fiscal />,
                },
                {
                    path: "expenditure/:id",
                    element: <FiscalExpenditure />
                },
                {
                    path: "expenditureResponse/:id",
                    element: <FiscalExpenditureResponse />
                },
                {
                    path: "museum/:id",
                    element: <FiscalMuseum />
                },
                {
                    path: "museumResponse/:id",
                    element: <FiscalMuseumResponse />
                },
                {
                    path: "operational",
                    element: <Operational />
                },
                {
                    path: "operational/:id",
                    element: <Operational />
                },
                {
                    path: "operationalView",
                    element: <OperationalView />
                },
                {
                    path: "operationalResponse/:id",
                    element: <OperationalResponse />
                },
                {
                    path: "operationalReport",
                    element: <OperationalReport />
                },
                {
                    path: "performance",
                    element: <Performance />
                },
                {
                    path: "performance/:id",
                    element: <Performance />
                },
                {
                    path: "performanceView",
                    element: <PerformanceView />
                },
                {
                    path: "performanceResponse/:id",
                    element: <PerformanceResponse />
                },
                {
                    path: "visitation",
                    element: <Visitation />
                },
                {
                    path: "visitation/:id",
                    element: <Visitation />
                },
                {
                    path: "visitationView",
                    element: <VisitationView />
                },
                {
                    path: "visitationResponse/:id",
                    element: <VisitationResponse />
                },

                {
                    path: "visitationMonthReport",
                    element: <VisitationMonthReport />
                },
                {
                    path: "visitationMonthDetailedReport",
                    element: <VisitationMonthDetailedReport />
                },
                {
                    path: "visitationMonthAdRentReport",
                    element: <VisitationMonthAdRentReport />
                },
                {
                    path: "visitationAnnualReport",
                    element: <VisitationAnnualReport />
                },

                {
                    path: "visitationAnnualAdRentReport",
                    element: <VisitationAnnualAdRentReport />
                },
                {
                    path: "siteAnnualReport",
                    element: <SiteAnnualReport />
                },
                {
                    path: "siteAssociateAnnualReport",
                    element: <SiteAssociateAnnualReport />
                },
                {
                    path: "siteAnnualProgrammingReport",
                    element: <SiteAnnualProgrammingReport />
                },
                {
                    path: "activity",
                    element: <Activity />
                },
                {
                    path: "report",
                    element: <Report />
                },
                {
                    path: "fiscalBreadcrump",
                    element: <FiscalBreadcrump />
                },
                {
                    path: "fiscalView",
                    element: <FiscalView />
                },
                {
                    path: "fiscalResponse/:id",
                    element: <FiscalResponse />
                },
                {
                    path: "admin",
                    element: <AdminAdd />
                },



            ],


        },
    ]);

    return (
        <RouterProvider router={router} />
    );
}

export default Navigation;